<template>
  <div class="page-root" id="baseTableManagement">
    <div class="horizontal-scroll" id="baseTableManagement-horizontal-scroll">
      <div class="jumbotron" id="baseTableManagement-jumbotron">
        <div class="container-fluid almost-fluid" id="baseTableManagement-container">
          <div class="row" id="baseTableManagement-row">

            <div class="col-4 col-lg-3" id="baseTableManagement-col">
              <select class="form-control" v-model="selectedBaseTable" name="select_base_table" id="select_base_table"
                required>
                <option value="PRODUCTLINE" id="Branche">
                  {{ 'Branche' | translate }}
                </option>
                <option value="Subbranche" id="Subbranche">
                  {{ 'Subbranche' | translate }}
                </option>
                <option value="INSURER" id="Maatschappij">
                  {{ 'Maatschappij' | translate }}
                </option>
                <option value="PRODUCT" id="Product">
                  {{ 'Product' | translate }}
                </option>
                <option value="COVER_CATEGORY" id="Dekking">
                  {{ 'Dekking' | translate }}
                </option>
                <option value="AFFINITY" id="Collectiviteit">
                  {{ 'Collectiviteit' | translate }}
                </option>
                <option value="MAPPING" id="Mapping">
                  {{ 'Mapping' | translate }}
                </option>
                <option value="SCHEMA_DEFINITION" id="Import SUIV Definitions">
                  {{ 'Import SUIV Definitions' | translate }}
                </option>
                <option value="ACORD_MAPPING" id="acordMapping">
                  {{ 'Acord mapping' | translate }}
                </option>
                <option value="CONTEXT_ITEMS" id="contextItems">
                  {{ 'Context mapping' | translate }}
                </option>
                <option value="FUNCTION_ITEMS" id="functionItems">
                  {{ 'Function mapping' | translate }}
                </option>
                <option value="GIM_OBJECT" id="functionItems">
                  {{ 'gim_object' | translate }}
                </option>
                <option value="VALUE_MAPPING" id="valuemapping">
                  {{ 'Value mapping' | translate }}
                </option>
                <option value="NO_CLAIMS_DISCOUNT" id="noclaimsdiscount">
                  {{ 'No_Claims_Discount' | translate }}
                </option>
                <option value="PACKAGE_DISCOUNTS" id="packagediscounts">
                  {{ 'Package_Discounts' | translate }}
                </option>
              </select>
            </div>

            <div class="col-6 col-xl-4 ml-auto text-right" id="baseTableManagement-col-text-right">
              <!-- SEARCH -->
              <div class="input-group" v-if="false" id="baseTableManagement-inputGroup"> <!-- todo -->
                <input :placeholder="'SEARCH' | translate" class="form-control border-right-0" type="search"
                  v-model="filter" id="baseTableManagement-search">
                <span class="input-group-append" id="baseTableManagement-input-group-append">
                  <div class="input-group-text bg-white"><i class="fa fa-search" aria-hidden="true"></i></div>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="container-fluid almost-fluid" id="baseTableManagement-container-fluid-almost-fluid">
        <productline-base-table v-if="selectedBaseTable === 'PRODUCTLINE'"></productline-base-table>
        <subbranche-table v-if="selectedBaseTable === 'Subbranche'"></subbranche-table>
        <insurer-base-table v-if="selectedBaseTable === 'INSURER'"></insurer-base-table>
        <product-base-table v-if="selectedBaseTable === 'PRODUCT'"></product-base-table>
        <cover-category-base-table v-if="selectedBaseTable === 'COVER_CATEGORY'"></cover-category-base-table>
        <affinity-base-table v-if="selectedBaseTable === 'AFFINITY'"></affinity-base-table>
        <mapping-base-table v-if="selectedBaseTable === 'MAPPING'"></mapping-base-table>
        <schema-definition-base-table v-if="selectedBaseTable === 'SCHEMA_DEFINITION'"></schema-definition-base-table>
        <acord-mapping-table v-if="selectedBaseTable === 'ACORD_MAPPING'"></acord-mapping-table>
        <function-items-table v-if="selectedBaseTable === 'FUNCTION_ITEMS'"></function-items-table>
        <context-items-table v-if="selectedBaseTable === 'CONTEXT_ITEMS'"></context-items-table>
        <gim-object-table v-if="selectedBaseTable === 'GIM_OBJECT'"></gim-object-table>
        <value-mapping-table v-if="selectedBaseTable === 'VALUE_MAPPING'"></value-mapping-table>
        <no-claims-discount-table v-if="selectedBaseTable === 'NO_CLAIMS_DISCOUNT'"></no-claims-discount-table>
        <package-discounts-table v-if="selectedBaseTable === 'PACKAGE_DISCOUNTS'"></package-discounts-table>
      </div>
    </div>
  </div>
</template>

<script>
import ProductlineBaseTable from './productline/ProductlineTable.vue'
import SubbrancheTable from './Subbranche/SubbrancheTable.vue'
import InsurerBaseTable from './insurer/InsurerTable.vue'
import ProductBaseTable from './product/ProductTable.vue'
import CoverCategoryBaseTable from './cover-category/CoverCategoryTable.vue'
import AffinityBaseTable from './affinity/AffinityTable.vue'
import MappingBaseTable from './mapping/MappingTable.vue'
import SchemaDefinitionBaseTable from './schema-definition/SchemaDefinitionTable.vue'
import AcordMappingTable from './acord-mapping/AcordMappingTable.vue'
import ContextItemsTable from '../admin/contextitems/ContextItemsTable.vue'
import FunctionItemsTable from '../admin/functionitems/FunctionItemsTable.vue'
import GimObjectTable from '../admin/gim-object/GimObjectTable.vue'
import ValueMappingTable from './valuemapping/ValueMappingTable.vue'
import NoClaimsDiscountTable from './NoClaimsDiscount/NoClaimsDiscountTable.vue'
import PackageDiscountsTable from './PackageDiscounts/PackageDiscountsTable.vue'

export default {
  components: { ProductlineBaseTable, SubbrancheTable, ProductBaseTable, InsurerBaseTable, CoverCategoryBaseTable, AffinityBaseTable, MappingBaseTable, SchemaDefinitionBaseTable, AcordMappingTable, ContextItemsTable, FunctionItemsTable, GimObjectTable, ValueMappingTable, NoClaimsDiscountTable, PackageDiscountsTable },
  data() {
    return {
      selectedBaseTable: 'PRODUCTLINE',
      filter: ''
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/BaseTableManagement.vue